import {
  select,
  getItemLocalStorage,
  setItemLocalStorage,
} from "@utils/function";

// ------------------------------------------------------------
// remove round from favorites and localstorage

export default function RemoveRowAndUpdateLocalStorage(rowId) {
  const rounds = select(`#player-favorites-${rowId}`);
  rounds?.remove();

  const getFavorite = getItemLocalStorage("HQfavoritePlayers");

  const removeNumberFromFavorite = getFavorite.filter((id) => id !== rowId);
  setItemLocalStorage("HQfavoritePlayers", removeNumberFromFavorite);
}
